import { set } from "@/utils/vuex";

export default {
  setGlobalEventFilter: set("globalEventFilter"),
  setGlobalYearFilter: set("globalYearFilter"),
  setGlobalSelectedEvent: set("globalSelectedEvent"),

  // setAllFetchedEvents: set('allFetchedEvents'),
  setFilterStallHolders: set("filterStallHolders"),
  setFilterVouchers: set("filterVouchers"),
  // setFilterStalls: set('filterStalls'),
  // setFilterTerminalUser: set('filterTerminalUsers'),
  // setFilterTerminals: set('filterTerminals'),
  setFilterYear: set("filterYear"),

  setSearchStartTime: set("searchStartTime"),
  setSearchEndTime: set("searchEndTime"),
  setSearchStallholders: set("searchStallholders"),
  setSearchStalls: set("searchStalls"),
  setSearchTerminals: set("searchTerminals"),
  setDeviceId: set("deviceId"),
  setStan: set("stan"),
  setTotalAmount: set("totalAmount"),

  setAllYears: set("allYears"),
  setAllEvents: set("allEvents"),
  // setAllTotalEvents: set('allTotalEvents'),
  // setEOD: set('EOD'),
  IsAdmin: set("IsAdmin"),
  setAllStallHolders: set("allStallHolders"),
  setAllVouchers: set("allVouchers"),
  setAllStalls: set("allStalls"),
  setAllTerminalUsers: set("allTerminalUsers"),
  // setAllTerminals: set('allTerminals'),

  resetFilterState(state) {
    state.globalEventFilter = {};
    state.globalAllEventFilter = {};
    state.globalYearFilter = {};
    state.globalSelectedEvent = {};

    state.searchStartTime = "notSet";
    state.searchEndTime = "notSet";
    state.searchStallholders = "notSet";
    state.searchStalls = "notSet";
    state.searchTerminals = "notSet";
    state.deviceId = "";
    state.stan = "";
    state.totalAmount = null;

    state.filterStallHolders = "all";
    state.filterYear = "";

    state.allYears = [];
    state.allEvents = [];
    state.IsAdmin = {};
    state.allStallHolders = [];
    state.allVouchers = [];
    state.allTerminalUsers = [];
    state.allStalls = [];
  },
};
